import React from "react";
import type { SVGProps } from "react";

const DexTVLIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8 7H5C3.89543 7 3 7.89543 3 9V13M8 7H16M8 7V5C8 3.89543 8.89543 3 10 3H14C15.1046 3 16 3.89543 16 5V7M16 7H19C20.1046 7 21 7.89543 21 9V13M21 13V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V13M21 13C21 13 17 15 12 15C7 15 3 13 3 13M12 11H12.01"
      stroke="#383838"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DexTVLIcon;

